import buildPipelineRecordRef from 'app/audit-logs/buildPipelineRecordRef';
import { useModalContext, MODAL_ACTIONS } from 'app/pipelines/ModalContext';

export default function usePipelinesAuditLogModal() {
  const {
    modalState: { pipeline, activeModal },
    closeModal,
  } = useModalContext();

  return {
    open: !!(pipeline && activeModal === MODAL_ACTIONS.OPEN_AUDIT_LOG),
    onClose: closeModal,
    recordRef: buildPipelineRecordRef(pipeline),
  };
}
